import http from "../../../utils/services/http-client";
import {GenerateOtpModel, SignInFormModel, ValidateOtpModel} from "../models";
import { SignUpFormModel } from "../models/SignUpFormModel";

class LoginService {
  SignUp(data: SignUpFormModel) {
    return http.post(`/User`, data);
  }

  SignIn(data: SignInFormModel) {
    return http.post("/Authentication/login", data);
  }
  generateOtp(model:GenerateOtpModel) {
    return http.post("/SendLoginOTP",model);
  }
  validateOtp(model:ValidateOtpModel) {
    return http.put("/ValidateLoginOTP",model);
  }
  LogOut() {
    return http.get("/sso/logOut");
  }
  getLoginMethod() {
    return http.get("/Setting/useOnlySSO");
  }
}

export default new LoginService();
